import React, { useEffect, useState } from 'react'

// MUI imports
import { styled } from '@mui/material/styles';
import List from "@mui/material/List";
import MenuItem from './menu_item/MenuItem';
import SubMenu from './sub_menu/SubMenu'

const FireNav = styled(List)({
    '& .MuiListItemButton-root': {
        paddingLeft: 24,
        paddingRight: 24,
        marginTop: 2
    },
    '& .MuiListItemIcon-root': {
        minWidth: 0,
        // marginRight: 8,
        // marginLeft: 8,
    },
    '& .MuiSvgIcon-root': {
        fontSize: 20,
    },
});

const SidebarMenu = ({ isDrawerOpen }) => {
    const [version, setVersion] = useState(0)

    useEffect(() => {
        if (!isDrawerOpen) {
            setVersion(version + 1)
        }
    }, [isDrawerOpen])

    return (
        <FireNav
            component="nav"
            aria-labelledby="nested-list-subheader">
            <MenuItem title="Dashboard" icon='tabler-smart-home' href='/dashboard' isDrawerOpen={isDrawerOpen} />
            <MenuItem title="Users" icon='fa7-solid:users' href='/users' isDrawerOpen={isDrawerOpen} />
            <MenuItem title="Platforms" icon='tdesign:control-platform' href='/platforms' isDrawerOpen={isDrawerOpen} />
            <MenuItem title="Assigned Numbers" icon='line-md:phone-off-loop' href='/phonenumbers' isDrawerOpen={isDrawerOpen} />
            <MenuItem title="Withdrawals" icon='hugeicons:reverse-withdrawal-02' href='/withdrawals' isDrawerOpen={isDrawerOpen} />
            <MenuItem title="Sms" icon='la:sms' href='/sms' isDrawerOpen={isDrawerOpen} />
            <MenuItem title="Charts" icon='tabler:chart-bar' href='/charts' isDrawerOpen={isDrawerOpen} />
            <MenuItem title="Settings" icon='lsicon:setting-outline' href='/app-config-settings' isDrawerOpen={isDrawerOpen} />
            {/* <SubMenu title="Call Us" icon='mdi:email-outline' isDrawerOpen={isDrawerOpen}>
                <MenuItem title="تنظیمات تماس" href='/contact-info' icon='prime:circle' isDrawerOpen={isDrawerOpen} child />
                <MenuItem title="پیام‌های دریافتی" href='/contact-messages' icon='prime:circle' isDrawerOpen={isDrawerOpen} child />
            </SubMenu> */}
        </FireNav>
    );
}

export default SidebarMenu